var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheriffLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0274 2.23755L17.9772 9.68753L25.8839 9.68337L21.3265 15.9283L25.8839 22.1731L17.9772 22.169L14.0274 29.619L10.0776 22.169L2.1709 22.1731L6.72833 15.9283L2.1709 9.68337L10.0776 9.68753L14.0274 2.23755Z",
    fill: "#e2c6ae"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9697,
    cy: 2.20749,
    r: 2,
    fill: "#e2c6ae"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9697,
    cy: 29.589,
    r: 2,
    fill: "#e2c6ae"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.8593,
    cy: 9.77341,
    r: 2,
    fill: "#e2c6ae"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.1406,
    cy: 9.77341,
    r: 2,
    fill: "#e2c6ae"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.8593,
    cy: 21.7227,
    r: 2,
    fill: "#e2c6ae"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.1406,
    cy: 21.7227,
    r: 2,
    fill: "#e2c6ae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheriffLight);
export default __webpack_public_path__ + "static/media/sheriff_light.9984be924cfbb5755f0ead13b6be99f9.svg";
export { ForwardRef as ReactComponent };